import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AuthService } from '../../../../services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mfa-verification',
  imports: [CommonModule, FormsModule],
  templateUrl: './mfa-verification.component.html',
  styleUrl: './mfa-verification.component.css'
})
export class MfaVerificationComponent {

  router = inject(Router);
  @Output() emitterOpenTerms = new EventEmitter<boolean>();
  @Output() emitterPendingLoginData = new EventEmitter<any>();


  @Input() session: string = '';
  @Input() username: string = '';

  @Output() token = new EventEmitter<string>();

  mfaCode: string = '';
  errorMessage: string = '';

  constructor (private authService: AuthService) { }


  onVerifyCode () {
    this.errorMessage = '';
    if (!this.mfaCode) {
      this.errorMessage = 'Devi inserire il codice di verifica.';
      return;
    }

    if (!this.session || !this.username) {
      this.errorMessage = 'Sessione o username non validi.';
      return;
    }

    if (this.mfaCode.length < 6) {
      this.errorMessage = 'Il codice di verifica deve essere lungo 6 caratteri.';
      return;
    }

    this.authService.verifyMfaCode(this.username, this.mfaCode, this.session).subscribe(async (data) => {
      if (data.accessToken) {
        sessionStorage.setItem('access_token', data.accessToken);
        sessionStorage.setItem('username', data.username);
        const companyId = data.companyId.toString();
        sessionStorage.setItem('companyId', companyId);
        sessionStorage.setItem('setup', JSON.stringify({
          companyName: data.companyName || '',
          companyRole: data.companyRole || '',
          role: data.role || '',
          regionsIds: data.regionsIds || []
        }));

        if (!data.hasAcceptedTerms) {
          // open terms and conditions if the user hasn't accepted yet
          //this.openTerms = true;
          this.emitterPendingLoginData.emit(data);
          //this.isTermsOpen = true;
          this.emitterOpenTerms.emit(true);
          return;
        }

        this.token.emit(data.accessToken);
        this.router.navigate(['/dashboard']);
      }
    })

  }

}
